/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';
import { bool, func } from 'prop-types';

const useStyles = makeStyles({
    container: {
        marginRight: '17px',
        '& input': {
            cursor: 'pointer',
            position: 'absolute',
            opacity: 0,
            zIndex: '2',
        },
        '& input:checked + label svg path': {
            strokeDashoffset: 0,
        },
        '& input:focus + label': {
            transform: 'scale(1.03)',
        },
        '& input:checked + label': {
            background: '#E8F1ED',
        },
        '& input + label': {
            display: 'block',
            border: '2px solid #6E3290',
            width: 'var(--size)',
            height: 'var(--size)',
            borderRadius: '3px',
            transition: 'all .2s ease',
            cursor: 'pointer',
        },
        '& input + label:active': {
            transform: 'scale(1.05)',
            borderRadius: '6px',
        },
        '& input + label svg': {
            pointerEvents: 'none',
            paddingBottom: '10%',
            margin: '5%',
        },
        '& input + label svg path': {
            fill: 'none',
            stroke: '#6E3290',
            strokeWidth: '7px',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeDasharray: '100',
            strokeDashoffset: '101',
            transition: 'all 250ms cubic-bezier(1,0,.37,.91)',
        },
    },
});

const Checkbox = ({ onChange, checked }) => {
    const classes = useStyles();

    const handleChecbox = (e) => {
        onChange(e, e.target.checked);
    };

    return (
        <div className={classes.container}>
            <input type="checkbox" id="check" checked={checked} onChange={handleChecbox} />
            {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
            <label htmlFor="check" style={{ '--size': '20px' }}>
                <svg viewBox="0,0,50,50">
                    <path d="M5 30 L 20 45 L 45 5" />
                </svg>
            </label>
        </div>
    );
};

Checkbox.propTypes = {
    onChange: func.isRequired,
    checked: bool.isRequired,
};

export default Checkbox;
